import { getBulkData } from './getBulkData'
import { getData } from './getData'

export const TypeTicketCollectionController = {
  getData,
  getBulkData,
}
